import { render, staticRenderFns } from "./TermsOfServiceDialog.vue?vue&type=template&id=8c1a1226"
import script from "./TermsOfServiceDialog.vue?vue&type=script&lang=js"
export * from "./TermsOfServiceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports